export const formatPhoneNumber = (phoneNumber: string): string => {
  const match = phoneNumber.match(/(\+\d)(\d{3})(\d{3})(\d{2})(\d{2})/);
  if (!match) {
    return phoneNumber;
  }

  return `${match[1]} (${match[2]}) ${match[3]}-${match[4]}-${match[5]}`;
};
